import React from "react";
//import "../../style/apropos.css"
import "./style/nosvaleurs.css"
import axios from 'axios';

const Value = props => (
  <div style={{ width: "315px", height: "215px", background: props.value.color }} className="col grid_1_of_9">
    <div style={{paddingTop: "20px"}}>
      <center><h1 className="StyleTitle">{props.value.title}</h1></center>
    </div>
    <div style={{ width: "54%", margin: "0 auto" }}>
      <p className="StyleP">{props.value.description}</p>
    </div>
  </div>

)

class NosValeurs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Values: []
    };
  }    
  
  componentDidMount() {
    axios.get(`${process.env.REACT_APP_SERVER}`+'/value/')
      .then(response => {
        var values_to_add = response.data;
        values_to_add.splice(values_to_add.length-2, 0, {});
        values_to_add.splice(values_to_add.length-1, 0, {});
        this.setState({ Values: values_to_add })
      })
      .catch((error) => {
        console.log(error);
      })
    //this.updateValueList();  
  }

  updateValueList = (Values) => {
    var index = Values.length + 1;
    var new_values = Values
    while (new_values.length < 9){
      var index = index - 2;
      new_values= new_values.splice(index, 0, {});
    }
    return new_values
  }

  ValueList() {
    return this.state.Values.map(currentValue => {
      return <Value value={currentValue} key={currentValue._id}/>;
    })
  }

  render() {
    return (
      <div>
        <div className="banniereValuers">
          <div style={{ width: "945px", margin: "0 auto" , maxWidth: "1200px", wordWrap: "break-word" }} className="section">

            <div style={{ width: "315px", height: "215px" }} className="col grid_1_of_9"><h2 style={{ color: "white", fontFamily: "Oswald", fontSize: "30px", marginTop: "25%",letterSpacing:"8px",wordSpacing:"3px"}}>NOS VALEURS</h2></div>
            {this.ValueList()}
          </div>
        </div>
      </div>

    );
  }
}
export default NosValeurs;


// WEBPACK FOOTER //
// ./src/home/NosValeurs.js